import { render, staticRenderFns } from "./ConventionObligations.vue?vue&type=template&id=c5d009b0&scoped=true"
import script from "./ConventionObligations.vue?vue&type=script&lang=js"
export * from "./ConventionObligations.vue?vue&type=script&lang=js"
import style0 from "./ConventionObligations.vue?vue&type=style&index=0&id=c5d009b0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d009b0",
  null
  
)

export default component.exports